import cn from "classnames";
import { NavigationIcon } from "../navigation-icon";
import { hasDateLimit } from "../utils";
import { MONTHS_ABBRS } from "./constants";
import { MonthsProps } from "./types";
import styles from "./styles.module.scss";

export const Months = ({
  minDate,
  maxDate,
  viewDate,
  onSelectMonth,
  showStartPanel,
  dataTestId,
}: MonthsProps) => {
  const viewYear = viewDate?.getFullYear();
  const viewMonthIndex = viewDate?.getMonth();
  const minMonth =
    minDate && new Date(minDate.getFullYear(), minDate.getMonth());

  const maxMonth =
    maxDate && new Date(maxDate.getFullYear(), maxDate.getMonth());

  const isDisabledMonth = (monthIndex: number) => {
    const checkedMonth = new Date(viewYear, monthIndex);

    return hasDateLimit(checkedMonth, minMonth, maxMonth);
  };

  return (
    <div className={styles.panel} data-test-id={dataTestId}>
      <header className={styles.header}>
        <NavigationIcon
          direction="left"
          onClick={showStartPanel}
          dataTestId={`${dataTestId}-back`}
        />
        <span className={styles.title}>Выберите месяц</span>
      </header>
      <div className={styles.months}>
        {MONTHS_ABBRS.map((month, monthIndex) => (
          <span
            className={cn(styles.month, {
              [styles.selected]: monthIndex === viewMonthIndex,
              [styles.disabled]: isDisabledMonth(monthIndex),
            })}
            onClick={() => onSelectMonth(monthIndex)}
            key={`month-${monthIndex}`}
          >
            {month}
          </span>
        ))}
      </div>
    </div>
  );
};
